  <template>
    <div>
      <!-- 篩選 -->
      <div class="card filter-card">
        <div class="card-body">
          <div class="row">
            <div v-if="!filterVisible" class="filter-toggle-icon" @click="toggleFilter">
              <i class="fa fa-search"></i>
            </div>
            <div class="row" v-else>
              <div class="col-12 filter-header">
                <button class="btn btn-toggle" @click="toggleFilter">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="col-12 col-xl-8">
                <div class="row">
                  <!-- 篩選欄位 -->
                  <div class="col-12 col-md-6 mt-0">
                    <label for="name">Name</label>
                    <input type="text" id="name" class="form-control" v-model="filters.name" />
                  </div>
                  <div class="col-12 col-md-3 mt-0">
                    <label for="driver-id">Driver ID</label>
                    <input type="text" id="driver-id" class="form-control" v-model="filters.driverId" />
                  </div>
                  <div class="col-12 col-md-3 mt-3 mt-md-0">
                    <label for="plate-number">Plate number</label>
                    <input type="text" id="plate-number" class="form-control" v-model="filters.plate" />
                  </div>
                  <div class="col-12 col-md-3 mt-3">
                    <label for="license-number">License number</label>
                    <input type="text" id="license-number" class="form-control" v-model="filters.license" />
                  </div>
                  <div class="col-12 col-md-3 mt-3">
                    <label for="mobile-number">Mobile number</label>
                    <input type="text" id="mobile-number" class="form-control" v-model="filters.mobile" />
                  </div>
                  <div class="col-12 col-md-3 mt-3">
                    <label for="last-terminal-used">Last terminal used</label>
                    <input type="text" id="last-terminal-used" class="form-control" v-model="filters.lastTerminalUsed" />
                  </div>
                  <div class="col-12 col-md-3 mt-3">
                    <label for="payment-method">Payment method</label>
                    <select id="payment-method" class="form-control" v-model="filters.paymentMethod">
                      <option value="">All</option>
                      <option value="Bank">Bank</option>
                      <option value="Cash">Cash</option>
                    </select>
                  </div>
                  <div class="col-12 col-md-3 mt-3">
                    <label for="abn">ABN</label>
                    <input type="text" id="abn" class="form-control" v-model="filters.abn" />
                  </div>
                  <div class="col-12 col-md-3 mt-3">
                    <label for="subgroup">Subgroup</label>
                    <select id="payment-method" class="form-control" v-model="filters.subgroup">
                      <option value="">Select...</option>
                      <option v-for="item in subgroupStore.subgroups" :key="item.id" :value="item.id">{{item.name}}</option>
                    </select>                
                  </div>
                  <div class="col-12 col-md-3 mt-3">
                    <label for="from-date">From</label>
                    <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.last_updated_from" :enable-time-picker="false" data-language="en" placeholder="Select date" />
                  </div>
                  <div class="col-12 col-md-3 mt-3">
                    <label for="to-date">To</label>
                    <Datepicker1 class="datepicker-here form-control" :format="format" v-model="filters.last_updated_to" :enable-time-picker="false" data-language="en" placeholder="Select date" />
                  </div>
                </div>
              </div>
              <div class="col-12 col-xl-4">
                <div class="row align-items-end h-100">
                  
                  <div class="col-6">
                    <div class="row align-items-end">
                      <div class="col-12">
                        <div class="checkbox checkbox-success checked_green">
                          <input id="include-bad-drivers" type="checkbox" v-model="filters.includeBadDrivers">
                          <label for="include-bad-drivers">Include bad drivers</label>
                        </div>
                      </div>
                      <div class="col-12 col-md-12">
                        <div class="checkbox checkbox-success checked_green mt-2">
                          <input id="bad-drivers-only" type="checkbox" v-model="filters.badDriversOnly">
                          <label for="bad-drivers-only">Bad drivers only</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <button class="btn btn-reset btn-sm mx-lg-0 mx-auto" @click="resetFilters">Reset</button>
                    <button class="btn btn-search btn-sm mt-2 mx-lg-0 mx-auto" @click="search">Search</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- DataTable -->
      <div class="card mt-4" v-if="paginatedData !=''">
        <div class="card-body" >
          <div class="table-responsive signal-table" >
            <table class="table table-hover">
              <thead>
                <tr>
                  <th 
                    @click="sortTable('created_at')" 
                    :class="{'sortable col-driver-id': true, 'active': filters.sort_by === 'created_at'}">
                    <span>Created &nbsp;</span>
                    <i v-if="filters.sort_by === 'created_at' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                    <i v-if="filters.sort_by === 'created_at' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                  </th>
                  <th 
                    @click="sortTable('driver_id')" 
                    :class="{'sortable col-driver-id': true, 'active': filters.sort_by === 'driver_id'}">
                    <span>Driver ID &nbsp;</span>
                    <i v-if="filters.sort_by === 'driver_id' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                    <i v-if="filters.sort_by === 'driver_id' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                  </th>
                  <th 
                    @click="sortTable('first_name')" 
                    :class="{'sortable col-driver-name': true, 'active': filters.sort_by === 'first_name'}">
                    <span>Driver name &nbsp;</span>
                    <i v-if="filters.sort_by === 'first_name' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                    <i v-if="filters.sort_by === 'first_name' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                  </th>
                  <th 
                    @click="sortTable('plate_number')" 
                    :class="{'sortable col-plate': true, 'active': filters.sort_by === 'plate_number'}">
                    <span>Plate &nbsp;</span>
                    <i v-if="filters.sort_by === 'plate_number' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                    <i v-if="filters.sort_by === 'plate_number' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                  </th>
                  <th 
                    @click="sortTable('abn')" 
                    :class="{'sortable col-abn': true, 'active': filters.sort_by === 'abn'}">
                    <span>ABN &nbsp;</span>
                    <i v-if="filters.sort_by === 'abn' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                    <i v-if="filters.sort_by === 'abn' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                  </th>
                  <th scope="col" class="col-subgroup">Subgroup</th>
                  <th scope="col" class="col-last-terminal-used">Last terminal used</th>
                  <th 
                    @click="sortTable('bsb')" 
                    :class="{'sortable col-bsb': true, 'active': filters.sort_by === 'bsb'}">
                    <span>BSB &nbsp;</span>
                    <i v-if="filters.sort_by === 'bsb' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                    <i v-if="filters.sort_by === 'bsb' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                  </th>
                  <th 
                    @click="sortTable('account_no')" 
                    :class="{'sortable col-account_no': true, 'active': filters.sort_by === 'account_no'}">
                    <span>Account no. &nbsp;</span>
                    <i v-if="filters.sort_by === 'account_no' && filters.order === 'asc'" class="fa fa-sort-asc"> </i>
                    <i v-if="filters.sort_by === 'account_no' && filters.order === 'desc'" class="fa fa-sort-desc"></i>
                  </th>
                  <th scope="col" class="col-bad-driver">Bad driver</th>
                  <th scope="col" class="col-enabled">Enabled</th>
                  <th scope="col" class="col-actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in paginatedData" :key="index">
                  <td>{{ item.created_at }}</td>
                  <td>{{ item.driver_id }}</td>
                  <td>{{ item.first_name }}&nbsp;{{ item.middle_name }}&nbsp;{{ item.last_name }}</td>
                  <td>{{ item.plate }}</td>
                  <td>{{ item.abn }}</td>
                  <td v-if="item.subgroup">{{ item.subgroup }}</td>
                  <td v-else>None</td>
                  <td>{{ item.last_terminal_used }}</td>
                  <td>{{ item.bsb }}</td>
                  <td>{{ item.account_no }}</td>
                  <td>
                    <i :class="item.bad_driver ? 'fa fa-check text-success' : ''"></i>
                  </td>
                  <td>
                    <i :class="item.enabled ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                  </td>
                  <td>
                    <DriverEditModal :driverId="item.id" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        <!-- 分頁 -->
        <div class="pagination-wrapper" v-if="paginatedData !=''">
            <div class="pagination-container">
              <button @click="changePage(1)" :disabled="currentPage === 1">
                <img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" />
              </button>
              <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
                <img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" />
              </button>
              <span>
                Page
                <input type="number" v-model.number="currentPage" @change="changePage(currentPageInput)" />
                of {{ totalPages }}
              </span>
              <button @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
                <img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" />
              </button>
              <button @click="changePage(totalPages)" :disabled="currentPage === totalPages">
                <img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" />
              </button>
            </div>
            <div class="total-count">
              Displaying drivers {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, totalEntries) }} of {{ totalEntries }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-results">No results found.</div>
    </div>
  </template>

  <script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useDriverStore } from '@/store/admin/driver';
  import DriverEditModal from './editModal.vue';
  import { useSubgroupStore } from '@/store/admin/subgroup';
  import Datepicker1 from '@vuepic/vue-datepicker';

  const driverStore = useDriverStore();
  const subgroupStore = useSubgroupStore();

  const filterVisible = ref(false); // 控制查詢器是否顯示


    // 表格排序處理邏輯
  const sortTable = (field) => {
    if (filters.value.sort_by === field) {
      filters.value.order = filters.value.order === 'asc' ? 'desc' : 'asc';
    } else {
      filters.value.sort_by = field;
      filters.value.order = 'desc';
    }
    search();  // 重新調用API進行查詢
  };

  const filters = ref({
    name: '',
    driverId: '',
    plate: '',
    license: '',
    mobile: '',
    lastTerminalUsed: '',
    paymentMethod: '',
    abn: '',
    subgroup: '',
    includeBadDrivers: false,
    badDriversOnly: false,
    last_updated_from: '',
    last_updated_to: '',
    sort_by:'created_at',
    order:'desc',
  });

  //篩選區塊切換
  const toggleFilter = () => {
    filterVisible.value = !filterVisible.value;
  };

  //篩選
  const search = () => {
    driverStore.currentPage = 1; // 重置頁面到第一页
    const formattedFilters = {
      ...filters.value,
      last_updated_from: formatDateForAPI(filters.value.last_updated_from),
      last_updated_to: formatDateForAPI(filters.value.last_updated_to)
    };
    driverStore.setFilters(formattedFilters); // 設定篩選條件
    driverStore.fetchDrivers();
  };

  const resetFilters = () => {
    filters.value = {
      name: '',
      driverId: '',
      plate: '',
      license: '',
      mobile: '',
      lastTerminalUsed: '',
      paymentMethod: '',
      abn: '',
      subgroup: '',
      includeBadDrivers: false,
      badDriversOnly: false,
      last_updated_from: '',
      last_updated_to: '',
      sort_by:'created_at',
      order:'desc',
    };
    driverStore.resetFilters(); // 重置store中的篩選條件
    driverStore.fetchDrivers(); // 重新加載數據
  };

  const format = (date) => {
    if (!date) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // 新增格式化日期為 YYYY-MM-DD 的方法
  const formatDateForAPI = (date) => {
    if (!date) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  const currentPage = computed(() => driverStore.currentPage);
  const itemsPerPage = computed(() => driverStore.itemsPerPage);

  const paginatedData = computed(() => driverStore.paginatedData);
  const totalPages = computed(() => driverStore.totalPages);
  const totalEntries = computed(() => driverStore.totalEntries);

  //分頁功能
  const changePage = (page) => {
    if (page >= 1 && page <= totalPages.value) {
      driverStore.changePage(page); // 改變頁面
      driverStore.fetchDrivers(); // 重新加載數據
    }
  };

  onMounted(() => {
    currentPage.value = 1;
    changePage(1); // 重置分页到第一页
    driverStore.fetchDrivers(); // 加載時獲取數據
    subgroupStore.fetchSubgroups(1, 9999)
  });
  </script>
  
  <style scoped>
  .card {
    margin: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .card-body {
    padding: 20px;
    position: relative;
  }
  
  .table-responsive {
    margin-top: 20px;
  }
  
  .table-hover tbody tr:hover {
    background-color: #f1f1f1;
  }

  .table th.sortable {
  cursor: pointer;
  position: relative;
  padding-bottom: 10px;
}

.table th.sortable:hover {
  color: #00c962; /* Hover 時的文字顏色 */
}

.table th.active {
  color: #00c962; /* 當前排序的欄位文字顏色 */
}

  /* 排序箭頭樣式 */
  .sort-icon {
    width: 12px;
    height: 12px;
    margin-left: 5px;
    vertical-align: middle;
  }

  /* 排序欄位下的綠色下劃線 */
  .table th.active::after {
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    background-color: #00c962;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  
  /* 為表格欄位設定最小寬度 */
  .col-driver-id {
    min-width: 120px;
  }
  .col-driver-name {
    min-width: 150px;
  }
  .col-plate {
    min-width: 150px;
  }
  .col-abn {
    min-width: 150px;
  }
  .col-subgroup {
    min-width: 150px;
  }
  .col-last-terminal-used {
    min-width: 200px;
  }
  .col-bad-driver {
    min-width: 120px;
  }
  .col-enabled {
    min-width: 100px;
  }
  .col-select {
    min-width: 80px;
  }
  .col-actions {
    min-width: 100px;
  }
  .no-results {
    margin: 15px;
    border-radius: 20px;
    padding: 50px;
    font-size: 20px;
    text-align: center;
    color: black;
    background-color: #ccd3da;
  }
  
  .pagination-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
  }
  
  .pagination-container {
    display: flex;
    align-items: center;
  }
  
  .pagination-container button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 16px;
    color: #8476f4;
  }
  
  .pagination-container span {
    margin: 0 10px;
  }
  
  .pagination-container input {
    width: 50px;
    text-align: center;
  }
  
  .btn-reset {
   /* BTN_B */

    box-sizing: border-box;

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 14px 32px;
    gap: 10px;

    width: 150px;
    height: 46px;

    /* Green */
    border: 2px solid #00C962;
    border-radius: 30px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;

  }

  .btn-search {
  /* BTN_A_V2 */

  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px 32px;
  gap: 10px;

  width: 150px;
  height: 46px;

  /* Green */
  background: #00C962;
  border-radius: 30px;

  /* Inside auto layout */
  flex: none;
  order: 1;
flex-grow: 0;

  }

  .btn-reset:hover {
    background: white;
    border: 2px solid #00b452;
  }
  .btn-search:hover {
    background: #00b452;
    border: 2px solid #00b452;
  }

  
  .btn-green {
    margin-top: 20px;
    background-color: #00c962;
    height: 40px;
  }
  
  .btn-toggle {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
  }
  
  .filter-toggle-icon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-size: 24px;
    color: #666;
    cursor: pointer;
  }
  
  .total-count {
    font-size: 16px;
    color: #666;
  }
  
  .filter-header {
    display: flex;
    justify-content: flex-end;
  }
  
  .checkbox {
    display: flex;
    align-items: center;
    margin-top: 30px;
  }
  
  .checkbox input {
    margin-right: 8px;
  }
  
  .checkbox-success input {
    accent-color: #00c962;
  }
  
  .signal-table.table-responsive .table tbody tr td:nth-child(n+2) {
    min-width: 100px !important;
  }

  @media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }

  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}
  </style>
  